// Active menu item functionality functionality
import $ from 'jquery';

class Activemenu {
    constructor() {
        this.bannerSection = $("#banner");
        this.aboutSection = $("#about");
        this.servicesSection = $("#services");
        this.projectsSection = $("#projects");
        this.contactSection = $("#contact");
        this.headerLinks = $("header a svg");
        this.current = null;
        this.events();
    }
    events() {
        $(document).on("scroll", (e) => {
            if(this.isInViewport(this.bannerSection) && this.current !==this.bannerSection){
                this.resetAllActiveLinks();
                this.current = this.bannerSection;
            }
            if(this.isInViewport(this.aboutSection) && this.current !== this.aboutSection){
                this.resetAllActiveLinks();
                this.activateSectionLink(0);
                this.current = this.aboutSection;
            }
            if(this.isInViewport(this.servicesSection) && this.current !== this.servicesSection){
                this.resetAllActiveLinks();
                this.activateSectionLink(1);
                this.current = this.servicesSection;
            }
            if(this.isInViewport(this.projectsSection) && this.current !== this.projectsSection){
                this.resetAllActiveLinks();
                this.activateSectionLink(2);
                this.current = this.projectsSection;
            }
            if((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 2 && this.current !== this.contactSection) {
                this.resetAllActiveLinks();
                this.activateSectionLink(3);
                this.current = this.contactSection;
            }
        });
    }
    isInViewport(element) {
        const rect = element[0].getBoundingClientRect();
            return (
                rect.top <= 500 &&
                rect.top >=0
            );
    }
    resetAllActiveLinks() {
        this.headerLinks.each(function() {
            if(this.classList.contains("scrolled")){
                this.classList.remove("scrolled");
            }
        });
    }
    activateSectionLink(x) {
        this.headerLinks[x].classList.add("scrolled");
    }
}
export default Activemenu;